export default __webpack_public_path__ + "static/iso_18587-8367ef6d4d100055e4171144087b1fdb.webp";